/**
 * Created by wwei on 2018-11-09.
 */
import React, { Component } from "react";
import { translate } from "react-i18next";
import { Route, Switch } from "react-router-dom";

import TopBar from "../../../common/struct/TopBar";
import A4BSideBar from "./A4BSideBar";
import AmazonAccount from "../amazonAccount/AmazonAccount";
import ServiceConfig from "../serviceConfig/ServiceConfig";
import Footer from "../../../common/struct/Footer";
import { URL, SIDEBAR_WIDTH } from "../../../common/Constants";
import { saveGAView } from "../../../common/functions/GAUtils";

class A4BMainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenuWords: true
    };
  }

  componentDidMount() {
    saveGAView(this.props.location.pathname);
  }

  toggle = () => {
    this.setState({ showMenuWords: !this.state.showMenuWords });
  };

  render() {
    const { showMenuWords } = this.state;
    const { t } = this.props;
    const menuWidth = showMenuWords ? SIDEBAR_WIDTH.WIDTH : SIDEBAR_WIDTH.THIN;

    return (
      <div>
        <TopBar
          showMenuWords={showMenuWords}
          toggle={this.toggle}
          history={this.props.history}
          title={t("CLOUD_APPS.A4B.TITLE")}
          firstLink={URL.A4B.AMAZON_ACCOUNT}
        />
        <div className="ts-main-content">
          <A4BSideBar showMenuWords={showMenuWords} width={menuWidth} />
          <div className="content-wrapper" style={{ marginLeft: menuWidth }}>
            <Switch>
              <Route
                exact
                path={URL.A4B.SERVICE_CONFIG}
                component={ServiceConfig}
              />
              <Route
                exact
                path={URL.A4B.AMAZON_ACCOUNT}
                component={AmazonAccount}
              />
            </Switch>
            <Footer left={menuWidth} />
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(A4BMainPage);



// WEBPACK FOOTER //
// ./src/tenantportal/a4b/main/A4BMainPage.js